import { GameCondition, GameLock } from '../../../../../../_models/Game';
import { Tag } from '../../../../../../_models/Tag';
import { PolygonAction } from '../../../../../../_models/virtualStaging/Polygon';

export enum BackpackItemType {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  Tag = 'tag',
  Polygon = 'polygon',
  Condition = 'condition',
  CollectItem = 'collectItem',
}
export type BackpackOrigin = Tag | PolygonAction | GameCondition | GameLock;
export interface BackpackItem {
  id: number;
  preview: string;
  title: string;
  type: BackpackItemType;
  origin: BackpackOrigin;
}
export interface BackpackReelProps {
  items: BackpackItem[];
  openItem: (item: BackpackOrigin, type: BackpackItemType) => void;
  show: boolean;
  onToggleBackpackModal: () => void;
}
